import { makeObservable, observable } from 'mobx'

/*
    Needed, because these cards are used inside virtual scroll
    and their collapsed/expanded state must be persisted.

    Crating boxes, because otherwise all visitCards will be touched on each toggle.
*/

class VisitCardsExpansion {
  m = new Map()

  constructor() {
    makeObservable(this, {
      m: true,
      toggle: true,
      collapseAll: true,
    })
  }

  expanded(pendingVisitId) {
    let box = this.m.get(pendingVisitId)
    if (!box) {
      box = observable.box(false)
      this.m.set(pendingVisitId, box)
    }
    return box.get()
  }

  toggle(pendingVisitId) {
    let box = this.m.get(pendingVisitId)
    if (!box) {
      box = observable.box(true)
      this.m.set(pendingVisitId, box)
    } else {
      box.set(!box.get())
    }
  }

  collapseAll() {
    this.m.clear()
  }
}

export default new VisitCardsExpansion()
